import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import CommonDatePicker from "../../../components/CommonDatePicker";
import StatusComp from "../../../components/StatusComp";

const SiteAdminReport = () => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);

  const [data, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const location = useLocation();
  const type = location?.state?.type;

  const handlePreview = () => {
    console.log("From:", fromDate);
    console.log("To:", toDate);
    console.log("Company:", selectedCompany);
    console.log("Site:", selectedOption);
  };

  return (
    <div className="dashRightView">
      <StatusComp name={"Site"} type={"Report"} />
      <div className={`d-flex ${type ? "gap-5" : "gap-5"}`}>
        <CommonDatePicker
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />

        {/* Preview Button */}
        <div className="col-md-1 mt-4">
          <button
            onClick={handlePreview}
            className="submit-btn"
            disabled={
              !fromDate ||
              !toDate ||
              !selectedCompany?.label ||
              !selectedOption?.label
            }
          >
            Preview
          </button>
        </div>
      </div>
    </div>
  );
};

export default SiteAdminReport;
